import reduce from 'lodash/reduce';

import { theme } from '@sbv-clients/ui-shared';
import { formatDate } from '@sbv-clients/util-misc';

import { DashboardHppdHoursHourType } from '../../../services/dashboard';

type HppdGraphDataType = {
  scheduled: number[];
  min: number[];
  actual: number[];
  budgeted: number[];
  labels: string[];
};

export const transformToLineChart = (
  hppdData?: DashboardHppdHoursHourType[]
) => {
  const accumulator: HppdGraphDataType = {
    scheduled: [],
    min: [],
    actual: [],
    budgeted: [],
    labels: [],
  };
  const data = reduce(
    hppdData,
    (acc, item) => {
      acc.scheduled.push(item.scheduledHPPD || 0);
      acc.min.push(item.minHPPD || 0);
      acc.actual.push(item.actualHPPD || 0);
      acc.budgeted.push(item.budgetedHPPD || 0);
      if (item.date) {
        acc.labels.push(formatDate(new Date(item.date), 'M/d'));
      } else {
        acc.labels.push('-');
      }
      return acc;
    },
    accumulator
  );
  return {
    datasets: [
      {
        data: data.scheduled,
        label: 'Scheduled',
        borderColor: theme.custom?.chartScheduled,
        backgroundColor: theme.custom?.chartScheduled,
      },
      {
        data: data.min,
        label: 'Minimum',
        borderColor: theme.custom?.chartMin,
        backgroundColor: theme.custom?.chartMin,
      },
      {
        data: data.actual,
        label: 'Actual',
        borderColor: theme.custom?.chartActual,
        backgroundColor: theme.custom?.chartActual,
      },
      {
        data: data.budgeted,
        label: 'Budget',
        borderColor: theme.custom?.chartBudget,
        backgroundColor: theme.custom?.chartBudget,
      },
    ],
    labels: data.labels,
  };
};
